.inputs-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  flex: 1;
}

.add-cover-wrapper {
  width: 100%;

  & > div {
    & > div {
      height: 12.2rem;
      width: 100%;

      img {
        width: 100%;
      }
    }
  }

  @media screen and (min-width: $bp-medium) {
    width: 50%;
  }
}

.project-templates-container {
  height: 100%;
  padding: 1.6rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  & > p {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 1.8rem;
    color: var(--color-grayscale-white);
    margin-bottom: 1.6rem;
  }
}

.project-templates {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1.6rem;
  overflow-y: scroll;
}

.form {
  padding: 1.6rem;
  display: flex;
  flex-direction: column-reverse;
  gap: 1.6rem;
  width: 100%;
  height: 100%;
  border-bottom: 0.1rem solid var(--color-grayscale-trout);

  @media screen and (min-width: $bp-medium) {
    flex-direction: row;
    width: 48rem;
  }
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
}
